import React from 'react';

import OpsLeaderCard from './OpsLeaderCard';
import OpsAreas from './OpsAreas';
import { HierarchyUser, OpsAreaHierarchy } from '../../codegen/graphql';

type Props = {
    director: HierarchyUser;
    seniorExecutive: HierarchyUser;
    opsAreas: OpsAreaHierarchy[];
};

function OperationsTeam({ director, seniorExecutive, opsAreas }: Props) {
    return (
        <>
            <OpsLeaderCard personsRole="director" person={director} />
            <OpsLeaderCard
                personsRole="senior-executive"
                person={seniorExecutive}
            />
            <div className="mt-4 relative z-0">
                <OpsAreas opsAreas={opsAreas} />
            </div>
        </>
    );
}

export default OperationsTeam;
